import { render, staticRenderFns } from "./userReviewVideo.vue?vue&type=template&id=59ff0b3c&scoped=true&lang=html&"
import script from "./userReviewVideo.vue?vue&type=script&lang=ts&"
export * from "./userReviewVideo.vue?vue&type=script&lang=ts&"
import style0 from "./userReviewVideo.vue?vue&type=style&index=0&id=59ff0b3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ff0b3c",
  null
  
)

export default component.exports